/**
 * @generated SignedSource<<40c37b08f39583bd64e9b2be3c25ab9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useClubIsSellingPackages_club$data = {
  readonly packages: {
    readonly count: number;
  } | null | undefined;
  readonly " $fragmentType": "useClubIsSellingPackages_club";
};
export type useClubIsSellingPackages_club$key = {
  readonly " $data"?: useClubIsSellingPackages_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useClubIsSellingPackages_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "packageType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClubIsSellingPackages_club",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "packageType",
          "variableName": "packageType"
        },
        {
          "kind": "Literal",
          "name": "saleAvailability",
          "value": "PUBLIC"
        }
      ],
      "concreteType": "PackageConnection",
      "kind": "LinkedField",
      "name": "packages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "1a615f15d1b5f4b8b73794c4f234df9e";

export default node;
